import React from "react";
// import "./hero.scss";
import HeroImg from "../../social/assets/Herobg.png";

const HeroBanner1 = () => {
  return (
    <div className="heroContainer relative w-full h-[60vh] border overflow-hidden">
      <img
        src={HeroImg}
        alt="hero_Img"
        className="HeroImgContainer absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 before:bg-gradient-to-r from-black to-transparent"></div>
      <div className="relative z-10 text-white p-8 mt-8 ml-14">
        <div className="relative bg-gray-100 bg-opacity-5 p-8 rounded-md w-7/12">
          <h2 className="text-4xl font-bold mt-12">Your Personal Assistant</h2>
          <p className="text-xl mt-4">
            Simple and affordable way to get things done.
          </p>

          <form className="flex items-center mt-8 gap-4">
            <select
              id="countries"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-3/12 pr-2.5  py-2"
            >
              <option selected value="US">
                <svg
                  width="25"
                  height="40"
                  viewBox="0 0 25 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4 mr-2 text-gray-100 0 hover:text-gray-900 "
                >
                  <path
                    d="M12.4144 18.1592C12.9223 18.1602 13.4236 18.0438 13.8784 17.8191L16.0602 16.7358C16.6053 16.467 17.0637 16.0519 17.3834 15.5376C17.7031 15.0233 17.8713 14.4304 17.8689 13.826V10.6118C17.8708 10.0079 17.7023 9.41558 17.3827 8.90189C17.063 8.3882 16.6049 7.97366 16.0602 7.70521L13.8784 6.62189C13.4236 6.39744 12.9227 6.28064 12.4149 6.28064C11.9071 6.28064 11.4062 6.39744 10.9515 6.62189L8.76964 7.70521C8.22473 7.97351 7.76638 8.38798 7.44652 8.90169C7.12665 9.41539 6.95805 10.0078 6.95982 10.6118V13.826C6.95787 14.43 7.12627 15.0225 7.44593 15.5364C7.76559 16.0502 8.22376 16.465 8.76855 16.7336L10.9504 17.8169C11.405 18.0423 11.9062 18.1595 12.4144 18.1592ZM9.14164 13.826V10.6118C9.14338 10.5012 9.16214 10.3916 9.19727 10.2868L11.5755 11.4676C11.8359 11.5969 12.1232 11.6642 12.4144 11.6642C12.7056 11.6642 12.9928 11.5969 13.2533 11.4676L15.6315 10.2868C15.6666 10.3916 15.6853 10.5012 15.6871 10.6118V13.826C15.6879 14.0274 15.6319 14.2251 15.5252 14.3965C15.4186 14.5679 15.2656 14.7062 15.0838 14.7955L12.902 15.8789C12.7502 15.9534 12.5832 15.9922 12.4138 15.9922C12.2445 15.9922 12.0774 15.9534 11.9256 15.8789L9.74382 14.7955C9.56219 14.706 9.40949 14.5677 9.30305 14.3963C9.1966 14.2249 9.14068 14.0273 9.14164 13.826ZM20.0507 24.6592H17.0955L20.8995 21.1687C22.579 19.5009 23.7224 17.3756 24.1848 15.062C24.6471 12.7484 24.4077 10.3506 23.4967 8.17223C22.5858 5.99388 21.0444 4.13297 19.0677 2.82518C17.091 1.5174 14.7679 0.821572 12.3927 0.825825C10.0174 0.830078 7.6969 1.53422 5.72495 2.84908C3.753 4.16393 2.21835 6.03035 1.31534 8.21195C0.412334 10.3936 0.181601 12.7922 0.652363 15.1041C1.12312 17.416 2.2742 19.5372 3.95982 21.199L7.73327 24.6592H4.778C4.48868 24.6592 4.2112 24.7733 4.00661 24.9765C3.80203 25.1796 3.68709 25.4552 3.68709 25.7425C3.68709 26.0298 3.80203 26.3053 4.00661 26.5085C4.2112 26.7117 4.48868 26.8258 4.778 26.8258H20.0507C20.34 26.8258 20.6175 26.7117 20.8221 26.5085C21.0267 26.3053 21.1416 26.0298 21.1416 25.7425C21.1416 25.4552 21.0267 25.1796 20.8221 24.9765C20.6175 24.7733 20.34 24.6592 20.0507 24.6592ZM5.47182 5.8484C7.30905 4.01577 9.80414 2.98295 12.4082 2.97716C15.0123 2.97137 17.512 3.99308 19.3575 5.81752C21.2029 7.64197 22.243 10.1197 22.2488 12.7056C22.2546 15.2916 21.2258 17.7739 19.3885 19.6066L15.0413 23.5943C14.3268 24.263 13.3811 24.634 12.3992 24.6305C11.4174 24.6271 10.4743 24.2496 9.76455 23.5758L5.47182 19.6369C3.6332 17.807 2.60061 15.3276 2.60061 12.7426C2.60061 10.1577 3.6332 7.67827 5.47182 5.8484Z"
                    fill="#0B0D11"
                  />
                </svg>
                United States
              </option>
              <option value="CA">Canada</option>
              <option value="FR">France</option>
              <option value="DE">Germany</option>
            </select>

            <div className="relative w-full">
              <input
                type="text"
                id="voice-search"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 "
                placeholder="Find your service here e.g. AC, Car, Facial"
                required
              />
              <button
                type="button"
                className="absolute inset-y-0 right-0 flex items-center pr-3"
              >
                <svg
                  className="w-4 h-4 text-gray-500  hover:text-gray-900 "
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 16 20"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M15 7v3a5.006 5.006 0 0 1-5 5H6a5.006 5.006 0 0 1-5-5V7m7 9v3m-3 0h6M7 1h2a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3Z"
                  />
                </svg>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner1;
